<script setup>
import { useLohndatenStore } from '@/stores/lohndaten'
import { value } from 'lodash-es'
import { ref } from 'vue'
import { nextTick } from 'vue'
import { watch } from 'vue'

const props = defineProps({
  min: {
    type: Number,
    required: true
  },
  max: {
    type: Number,
    required: true
  },
  label: {
    type: String,
    required: true
  },
  suffix: {
    type: String,
    required: false
  },
  suffixSingular: {
    type: String,
    required: false
  },
  labelZero: {
    type: String,
    required: false
  },
  name: {
    type: String,
    required: true
  },
  placeholder: {
    type: String,
    required: false
  },
  stepSize: {
    type: Number,
    required: false,
    default: 1
  },
  total: {
    type: Number,
    required: false,

  }
})

const store = useLohndatenStore()
const emit = defineEmits(['complete'])

function onChange(option) {
  store[props.name] = +option.toFixed(1)
  emit('complete')
}

function formatValue(inValue) {
  let value = Math.floor(+inValue.toFixed(1))

  if (value === 0 && props.labelZero) {
    return props.labelZero
  }

  if (value == 1 && props.suffixSingular) {
    return value + ' ' + props.suffixSingular
  }
  if (props.stepSize < 1 && value < inValue) {
    return value + ' ½ ' + props.suffix
  }
  return value + ' ' + props.suffix
}

const slider = ref(null)

watch(
  () => store[props.name],
  (newValue) => {
    if (newValue) {
      nextTick(() => {
        slider.value.update(newValue);
      });
    }
  }
);
</script>

<template>
  <SliderElement ref="slider" class="showLabel" :default="store[name]" :value="store[name]" :label="label || '...'"
    :name="name" :min="min" :max="max" :step="stepSize" @change="onChange" :format="formatValue"
    :slots="{ label: '<h2></h2>' }">
  </SliderElement>
</template>

<style scoped>
.vf-element-layout {
  padding: 2rem 2rem 2rem 2rem;
  border-radius: 29px;

  background-color: var(--color-grey);
}
</style>

<style>
.slider-panel {
  background-color: var(--color-grey);
  display: flex;
  flex-direction: column;
  align-items: center;
  border-radius: 29px;
}

.vf-slider-target,
.vf-slider-horizontal * {
  --vf-slider-height: 5px !important;
  --vf-bg-passive: #f9f1f1;
  --vf-slider-handle-size: 23px;
  --vf-slider-tooltip-distance: 0px;
  --vf-bg-slider-handle: #f9f1f1 !important;

  --vf-ring-color: #e2001a3b;
}

.vf-slider-handle {
  border: 5px solid #34333c;
}

.vf-slider-tooltip {
  background: transparent;
  color: #34333c;
  font-weight: normal;
  border: none;
}

.vf-slider-tooltip-top::before {
  display: none;
}

.vf-slider-connect {
  background-color: #f9f1f1;
}

.vf-slider-connects {
  border-top: solid 1px black;
  border-radius: 0px;
  transform: translateY(1.5px);
  cursor: pointer;
  border-radius: 0;
}
</style>
